<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 25">
    <path
      d="M6.4,19.5l-1.4-1.4,5.6-5.6-5.6-5.6,1.4-1.4,5.6,5.6,5.6-5.6,1.4,1.4-5.6,5.6,5.6,5.6-1.4,1.4-5.6-5.6-5.6,5.6Z"
    />
  </svg>
</template>
